module.exports = __webpack_public_path__ + "bichat-3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/novinky/bichat-3.png
// module id = 1859
// module chunks = 0